import React from 'react';
import styled from 'styled-components/macro';
import Modal from '../../components/Modal';
import { LinkStyled } from '../../components/typography';
import FadoelTypeView from '.';
import fadoelTypes from '../../content/commerce/fadoelTypes';
import getFadoelAlias from '../../content/commerce/fadoelAliases';
import { Div } from '../../components/grid';
import { BsFillPlusCircleFill } from '../../components/Icons';

const StyledModal = styled(Modal)`
  background: ${({ theme }) => theme.colors.colorGreyLight};
  width: 915px;
  height: 400px;
  transform: translate(0,0) !important;
  margin-right: 0 !important;
  margin-left: calc(-955px / 2);
  margin-top: calc(-400px / 2);

  @media (max-width: 991px) {
    width: 575px;
    margin-left: calc(615px / -2);
  }
  @media (max-width: 767px) {
    width: 460px;
    margin-left: calc(500px / -2);
  }
  @media (max-width: 575px) {
    width: calc(80% - 40px);
    margin-left: -40%;
  }

  @media (max-height: 700px) {
    top: 135px !important;
    height: calc(80% - 135px);
    margin-top: 0px;
  }
`;
const CloseButton = styled.div`
  color: ${({ theme }) => theme.colors.colorRed};
  border: 2px solid ${({ theme }) => theme.colors.colorWhite};
  position: absolute;
  display: flex;
  top: -7px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 40px;
  background: white;
  rotate: 45deg;
  border-radius: 100%;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${({ theme }) => theme.hoverColors.colorRed};
  }
`;
const OverflowY = styled(Div)`
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
`;
const OverflowHidden = styled(Div)`
  overflow: hidden;
  height: 100%;
`;
const stopPropagation = evt => evt.stopPropagation();

export default class FadoelTypePopup extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.onClose = this.onClose.bind(this);
    this.state = {
      open: false,
    };
  }

  onClick(evt) {
    evt.stopPropagation();
    this.setState({ open: true });
  }

  onClose(evt) {
    evt.stopPropagation();
    this.setState({ open: false });
  }

  render() {
    const {
      children,
      type,
    } = this.props;
    const typeAlias = getFadoelAlias(type);
    if (!fadoelTypes[typeAlias]) {
      return children;
    }
    const image = (
      <LinkStyled action onClick={this.onClick}>
        {children}
      </LinkStyled>
    );
    const { open } = this.state;
    if (open) {
      return (
        <React.Fragment>
          {image}
          <StyledModal
            isOpen
            onRequestClose={this.onClose}
            overflow
          >
            <OverflowHidden onClick={stopPropagation}>
              <OverflowY>
                <FadoelTypeView {...this.props} />
              </OverflowY>
              <CloseButton onClick={this.onClose}><BsFillPlusCircleFill /></CloseButton>
            </OverflowHidden>
          </StyledModal>
        </React.Fragment>
      );
    }
    return image;
  }
}
